export enum PlaceEnum {
    interno = 1,
    externo = 2
}